<!-- Doc: https://www.npmjs.com/package/vue-hash-calendar/v/1.4.30 -->

<template>
	<div
		class="c-calendar-wrap"
		:class="{
			'c-calendar-wrap--noToday': noToday
		}"
	>
		<div class="c-calendar-header">
			<div class="c-calendar-header-date">
				<div class="header-date-bold">{{ formatDateMonthAndDay }}</div>
				<div class="header-date-year">{{ formatDateYear }}</div>
			</div>
			<div class="c-calendar-header-control">
				<div class="header-control-today" @click="actionToday">{{ $t('enterprise.today') }}</div>
			</div>
		</div>
		<vue-hash-calendar
			ref="vCalendar"
			visible
			isShowArrow
			isShowWeekView
			:defaultDatetime="innerDateValue"
			:isShowAction="false"
			:disabledWeekView="true"
			todayClassName="custom-calendar-today"
			checkedDayClassName="custom-calendar-checked"
			firstDayOfMonthClassName="custom-calendar-first"
			@change="changeCalendar"
			@click="clickCalendarCell"
		>
			<template v-slot:week="scope">
				<div class="slot-calendar-week">{{ translateWeek(scope.week) }}</div>
			</template>
			<template v-slot:day="scope">
				<div class="slot-calendar-mask">
					<template v-if="includeStyleControl('circle-calendar')">
						<div
							v-for="(color, index) in generateLimitDisplayedColors(scope.date)"
							:key="index"
							:style="insetCalendarColorVar(color)"
							class="slot-calendar-dot"
						></div>
					</template>
				</div>
				<div v-if="scope.extendAttr.isToday" class="slot-calendar-today">
					{{ scope.date.day }}
				</div>
				<div v-else class="slot-calendar-day">{{ scope.date.day }}</div>
			</template>
			<template v-slot:arrow="scope">
				<div class="arrow-wrap">
					<m-svg-icon :name="scope.show ? 'arrow_down' : 'arrow_up'"></m-svg-icon>
				</div>
			</template>
		</vue-hash-calendar>
	</div>
</template>

<script>
import { calculateDateRange, filterDataByTimeRange, insetCalendarColorVar } from '@/store/modules/calendar';
import i18n, { EN } from '@/assets/js/i18n';

export default {
	props: {
		value: null,
		scheduleData: {
			type: Array,
			default: () => []
		},
		noToday: {
			type: Boolean,
			default: false
		},
		styles: {
			// ['circle-calendar']
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			insetCalendarColorVar
		};
	},
	computed: {
		innerDateValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('update:value', value);
			}
		},

		formatDateMonthAndDay() {
			return this.$moment(this.innerDateValue).format('MM/DD');
		},
		formatDateYear() {
			return this.$moment(this.innerDateValue).format(`YYYY${this.$t('enterprise.year')}`);
		},
		langIsEn() {
			return this.$i18n.locale === EN;
		}
	},
	methods: {
		includeStyleControl(styleType) {
			return this.styles.includes(styleType);
		},

		actionToday() {
			this.$refs.vCalendar.today();
		},
		changeCalendar(date) {
			this.innerDateValue = date;
		},
		clickCalendarCell(date) {
			this.$emit('cell-click', date);
		},

		// 日历圆点样式
		extractDistinctColors(date) {
			const originSchedule = this.scheduleData;
			const range = calculateDateRange(date, 'day');
			const rangeResult = filterDataByTimeRange(range, originSchedule);
			if (!rangeResult) return [];
			// 颜色去重
			return [...new Set(rangeResult.map(res => res.calendarThemeColor))];
		},
		generateLimitDisplayedColors(date) {
			const momentDate = this.$moment([date.year, date.month, date.day]);
			const toJsDate = momentDate._d;
			return this.extractDistinctColors(toJsDate).slice(0, 6);
		},

		translateWeek(value) {
			const days = {
				'一': 'monday',
				'二': 'tuesday',
				'三': 'wednesday',
				'四': 'thursday',
				'五': 'friday',
				'六': 'saturday',
				'日': 'sunday'
			};
			return this.$t(`enterprise.${days[value]}`);
		}
	}
};
</script>

<style>
/* 定位同步 */
.calendar_week {
	left: 0.533333333333333vw !important;
}
/* .calendar_group_li {
	left: 0 !important;
} */
.calendar_item {
	position: relative;
}
</style>
<style lang="less">
.c-calendar-wrap {
	&--noToday {
		.custom-calendar-checked .slot-calendar-mask {
			background: transparent !important;
		}
	}

	.c-calendar-header {
		padding: 0.12rem 0.14rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;

		.c-calendar-header-date {
			display: flex;
			align-items: baseline;

			.header-date-bold {
				color: #333;
				text-align: right;
				font-family: Barlow;
				font-size: 0.22rem;
				font-style: normal;
				font-weight: 600;
				line-height: 140%; /* 30.8px */
			}
			.header-date-year {
				margin-left: 0.12rem;
				color: #333;
				text-align: right;
				font-family: 'PingFang SC';
				font-size: 0.12rem;
				font-style: normal;
				font-weight: 500;
				line-height: 0.18rem; /* 150% */
			}
		}
		.c-calendar-header-control {
			.header-control-today {
				min-width: 0.2rem;
				min-height: 0.2rem;

				padding: 0 0.04rem;
				text-align: center;
				color: #666666;
				line-height: 0.2rem;
				font-family: 'PingFang SC';
				font-weight: 500;
				font-size: 0.12rem;
				border-radius: 0.02rem;
				background: #f6f7f8;
			}
		}
	}

	.arrow-wrap {
		height: 22px;
		background: #fff;

		.svg-icon {
			font-size: 0.18rem;
			color: #989898;
		}
	}

	.slot-calendar-week {
		color: #989898;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
	}
	.slot-calendar-day {
		text-align: center;
		font-family: Barlow-Regular;
		font-size: 0.16rem;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		position: relative;
	}
	.slot-calendar-today {
		color: var(--ir-theme-color);
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		position: relative;
	}
	.slot-calendar-mask {
		position: absolute;
		top: 2px;
		left: 0;
		right: 0;
		margin: auto;
		width: 0.28rem;
		height: 0.36rem;
		border-radius: 0.04rem;
		pointer-events: none;
		background: transparent;
		transition: background 0.2s ease-in-out;

		.slot-calendar-dot {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0.04rem;
			margin: auto;
			width: 0.04rem;
			height: 0.04rem;
			border-radius: 50%;
			background: var(--calendar-color);
		}
	}
	.custom-calendar-checked {
		.slot-calendar-mask {
			// width: auto;
			background: var(--ir-theme-color-opacity-1);
		}
		.slot-calendar-day {
			color: var(--ir-theme-color);
		}
	}
}
</style>
